<template>
    <!-- TAB：配置字段分组 -->
    <div class="fieldsgrouping group-sty">
        <!-- 左边字段列表 -->
        <div class="header">
            <h6 class="keylist">
                <ihelp helpName="配置字段分组" style="margin-right: 10px;cursor: pointer;"></ihelp> 选择需要分组的字段
            </h6>
            <div class="butns">
                <el-button size="small" type="test" class="addgroup" @click="sum()">保存并确定</el-button>
            </div>
        </div>
        <div class="center">
            <!-- 左边字段与值 -->
            <div class="single last" style="margin-right: 20px;">
                <el-table :data="cities" tooltip-effect="dark" style="width: 260px" @select="handleSelect"
                    @selection-change="handleSelectionChange" ref="multipleTable">
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column label="字段名称" prop="title"></el-table-column>
                    <el-table-column prop="value" label="值的个数" width="80">
                        <template>多值</template>
                    </el-table-column>
                </el-table>
            </div>
            <!-- 右边已分组字段 -->
            <div class="single last">
                <el-table :data="multipleSelection" stripe style="width: 450px">
                    <el-table-column prop="title" label="已分组字段" width="96">
                        <template slot-scope="scope">
                            <el-tooltip class="item" effect="dark" content="设为首字段" placement="left">
                                <div @click="handleCurrentChange(scope.row)" :class="{bold:scope.row.primary}">
                                    {{scope.row.fieldTitle}}
                                </div>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                    <el-table-column label="与首字段的关系" width="170px">
                        <template slot-scope="scope">
                            <div v-if="scope.row.primary">/（首字段）</div>
                            <div v-else>
                                <el-button round size="small" @click="one('1',scope.row)"
                                    :class="{highlight:scope.row.relation == 'ONE_2_ONE'}">一对一
                                </el-button>
                                <el-button round size="small" @click="one('2',scope.row)"
                                    :class="{highlight:scope.row.relation == 'ONE_2_MANY'}">一对多
                                </el-button>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column fixed="right" label="是否拼接" label-position="center" width="80px">
                        <template slot-scope="scope">
                            <el-checkbox v-model="scope.row.concatMultiLine"
                                :disabled="scope.row.relation == 'ONE_2_ONE' || !scope.row.relation ? true : false"></el-checkbox>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <!-- 抽屉组件 -->
        <Drawer></Drawer>
    </div>
</template>
<script>
    import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
    import bus from '@/assets/js/bus'
    import busType from '@/assets/js/busType'
    import ihelp from '../common/ihelp'
    import Drawer from '../common/Drawer'

    export default {
        name: 'DocGroup',
        props: ['mainInfo'],
        components: {
            ihelp,
            Drawer
        },
        data() {
            return {
                electboxshow: false,
                electboxshows: false,
                addshow: false,
                drawer: false,
                shou: false,
                lists: [],
                multipleSelection: [],
                arrmultipleTable: [],
                groupFields: new Map()
            }
        },
        created() {
            // this.$store.dispatch("setGroupList",)
        },
        computed: {
            ...mapState(['labelState']),
            ...mapGetters(['drawopen', 'configKey', 'groupList', 'editTemplate']),
            //判断，是多值的字段显示在左边数组
            cities() {
                let arr = []
                this.mainInfo.forEach(item => {
                    if (!item[1].fieldFilterRule.singleValue) {
                        arr.push({
                            title: item[1].fieldRuleList[0].title,
                            fieldName: item[0],
                            primary: '',
                            relation: ''
                        })
                    }
                })
                return arr
            }
        },
        watch: {
            drawopen(val) {
                this.drawer = true
            },
            '$store.state.labelState.groupList'() {
                // this.multipleSelection = val
                this.setGroupList()
            }
        },
        activated() {
            bus.$emit(busType.RESETINDENTITY)
        },
        mounted() {
            this.setGroupList()
        },
        methods: {
            setGroupList() {
                this.multipleSelection = this.$store.state.labelState.groupList || []
                //勾选左侧列表
                this.multipleSelection.forEach(item => {
                    let rowIdx = _.findIndex(this.cities, { fieldName: item.fieldName })
                    if (rowIdx != -1) {
                        this.$refs.multipleTable.toggleRowSelection(this.cities[rowIdx], true)
                    }
                })
                return
            },
            //一对多还是多对一的选择
            one(data, row) {
                for (let i = 0; i < this.multipleSelection.length; i++) {
                    if (this.multipleSelection[i].fieldName == row.fieldName) {
                        if (data == '1') {
                            this.multipleSelection[i].relation = 'ONE_2_ONE'
                            this.multipleSelection[i].concatMultiLine = false
                        } else {
                            this.multipleSelection[i].relation = 'ONE_2_MANY'
                        }
                        // stash relation
                        this.groupFields.set(
                            row.fieldName,
                            this.multipleSelection[i].relation
                        )
                    }
                }
                this.multipleSelection = [...this.multipleSelection]
            },
            handleClose(done) {
                done()
            },
            handleClick(row) {
                //console.log(row)
            },
            handleSelect(val, row) {
                let fieldName = row.fieldName
                if (this.groupFields.has(fieldName)) {
                    this.groupFields.delete(fieldName)
                }
            },
            // 左边框字段
            handleSelectionChange(val) {
                if (this.timer_selection) clearTimeout(this.timer_selection)
                this.timer_selection = setTimeout(() => {
                    let arr = []
                    //左侧列表选中的，且不在右侧列表里则添加到右侧列表
                    val.forEach(item => {
                        let index = _.findIndex(this.multipleSelection, {
                            fieldName: item.fieldName
                        })
                        if (index == -1) {
                            this.multipleSelection.push({
                                fieldName: item.fieldName,
                                fieldTitle: item.title,
                                primary: item.primary || false,
                                relation: item.relation
                            })
                        }
                    })
                    // 去掉未勾选项（左侧数组没有勾选的，不会被push进入右侧列表）
                    this.multipleSelection.forEach(item => {
                        let index = _.findIndex(val, { fieldName: item.fieldName })
                        if (index != -1) {
                            arr.push(item)
                        }
                    })
                    this.multipleSelection = arr

                    // this.multipleSelection.forEach((item,i) => {
                    //     let index = _.findIndex(val,{fieldName:item.fieldName})
                    //     if(index == -1){
                    //         this.multipleSelection.splice(i,1)
                    //     }
                    // });
                    // 排序
                    let that = this
                    this.multipleSelection.sort(function (a, b) {
                        return (
                            _.findIndex(that.cities, { fieldName: a.fieldName }) -
                            _.findIndex(that.cities, { fieldName: b.fieldName })
                        )
                    })
                }, 100)
            },
            //选择右边框字段
            handleCurrentChange(val) {
                this.multipleSelection.forEach(item => {
                    if (item.fieldName == val.fieldName) {
                        item.primary = true
                        item.relation = ''
                    } else {
                        item.primary = false
                    }
                })
            },
            //保存并确定的接口
            saveport() {
                let url = this.$resource.setGroup4Template.replace(
                    '{templateId}',
                    this.editTemplate.templateId
                )

                this.$axios({
                    url: url,
                    method: 'put',
                    data: {
                        groupList: [
                            {
                                fieldList: this.multipleSelection,
                                groupName: 'string'
                            }
                        ]
                    }
                })
                    .then(res => {
                        this.lists = res.config.data
                    })
                    .catch(e => {
                        console.log(e)
                    })
                this.$message({
                    message: '设置成功！',
                    type: 'success'
                })
            },
            //点击保存并确定按钮，调用接口
            sum() {
                let more = ''
                if (this.multipleSelection.length > 0) {
                    if (_.findIndex(this.multipleSelection, { primary: true }) == -1) {
                        this.$message({
                            message: '您未设置首字段',
                            type: 'warning'
                        })
                        return
                    }
                    //没有选对应关系的判断
                    this.multipleSelection.forEach(item => {
                        //没有选择一对一或者一对多
                        if (!item.relation) {
                            //primary是false，不是首字段)
                            if (!item.primary) {
                                more = 1
                            }
                        }
                    })
                    //more=1,则没有选择对应关系
                    if (more == 1) {
                        this.$message({
                            message: '您未设置对应关系',
                            type: 'warning'
                        })
                        return
                    } else {
                        this.saveport()
                    }
                } else {
                    this.saveport()
                }
            }
        }
    }
</script>
<style>
    .bold {
        font-weight: 700;
    }

    .fieldsgrouping::-webkit-scrollbar-thumb {
        background: transparent;
    }

    .fieldsgrouping.roll::-webkit-scrollbar-thumb {
        background: #cccccc;
    }

    .fieldsgrouping /deep/ .el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background-color: #fff;
        border-color: #dcdfe6;
    }

    .el-checkbox__input.is-checked .el-checkbox__inner,
    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background-color: null;
        border-color: null;
    }

    .overstriking {
        font-weight: 700;
    }

    .fieldsgrouping {
        color: var(--color-d4);
        height: calc(100% - 56px);
        overflow-y: auto;
        position: relative;
        padding: 20px;

        .header {
            width: 100%;
            display: flex;
            margin-bottom: 20px;

            .keylist {
                font-size: 20px;
                margin-top: 20px;
                font-weight: 700;
                display: inline-block;
                width: 40%;
            }

            .butns {
                display: inline-block;
                margin-left: 43%;
                margin-top: 30px;

                /* width: 50%; */
                .addgroup {
                    /* background-color: #3D7FFF; */
                    /* color: #fff; */
                    display: inline-block;
                }

                .editgroup {
                    margin-left: 20px;
                }
            }
        }

        .electbox {
            margin: 0 20px 0 10px;
        }

        .key {
            display: inline-block;
            width: 60%;
            text-align: right;
            font-size: 14px;
            color: var(--color-d4);
            flex-shrink: 0;
            text-align: center;
        }

        .center {
            display: flex;

            .single {
                border-bottom: 0;
                margin-bottom: 200px;
                width: 51%;
                display: inline-block;

                .relation {
                    width: 30%;
                }

                .el-button--small,
                .el-button--small.is-round {
                    padding: 6px 15px;
                }

                .editfield {
                    color: #3d7fff;
                    display: inline-block;
                    line-height: 20px;
                    text-align: center;
                    font-size: 12px;
                }

                .editfield :before {
                    display: inline-block;
                    line-height: 20px;
                    text-align: center;
                    font-size: 12px;
                    display: none;
                }
            }
        }

        .highlight {
            background-color: #3d7fff;
            color: #fff;
        }
    }

    .el-table .cell {
        padding-right: 0px;
    }

    /* .el-button--small, .el-button--small.is-round {
        padding: 6px 15px;
    }
    .el-button {
        border: 1px solid #3d7fff;
        color: #3d7fff;
    } */

    .group-sty {
        .header {
            display: flex;
            justify-content: space-between;
            margin-bottom: 10px !important;
        }

        .header .butns {
            display: block;
            margin: 0 !important;
        }
    }
</style>